import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=59fc1e63&scoped=true"
import script from "./product-info.vue?vue&type=script&lang=js"
export * from "./product-info.vue?vue&type=script&lang=js"
import style0 from "./product-info.vue?vue&type=style&index=0&id=59fc1e63&prod&lang=scss&scoped=true"
import style1 from "./product-info.vue?vue&type=style&index=1&id=59fc1e63&prod&lang=scss"
import style2 from "./product-info.vue?vue&type=style&index=2&id=59fc1e63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fc1e63",
  null
  
)

export default component.exports